var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDesign2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.67743 2.32524C3.05014 0.710852 4.661 -0.295727 6.27539 0.0769836L13.7985 1.81383C15.4129 2.18654 16.4195 3.7974 16.0467 5.41179L14.3099 12.9349C13.9372 14.5493 12.3263 15.5558 10.7119 15.1831L3.18884 13.4463C1.57445 13.0736 0.567875 11.4627 0.940586 9.84833L2.67743 2.32524Z",
    fill: "#6E2C00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesign2);
export default __webpack_public_path__ + "static/media/design2.134981051a8556eaf98e28415c70ff0d.svg";
export { ForwardRef as ReactComponent };